module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo15-4e57de4dc5491a566fee150da1722598.jpg";